import React from 'react';
export default function PhotoCamera(_a) {
    var className = _a.className;
    return (React.createElement("svg", { className: className, width: "1em", height: "1em", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 -960 960 960" },
        React.createElement("path", { xmlns: "http://www.w3.org/2000/svg", d: "M479.5-267q72.5 0 121.5-49t49-121.5-49-121T479.5-607t-121 48.5-48.5 121T358.5-316t121 49m0-60q-47.5 0-78.5-31.5t-31-79 31-78.5 78.5-31 79 31 31.5 78.5-31.5 79-79 31.5M80-120v-633h207l73-87h240l73 87h207v633zm60-60h680v-513H645l-73-87H388l-73 87H140zm340-257" })));
}
